module.exports = __webpack_public_path__ + "static/media/SpaceGrotesk-Regular.5529b729.woff2";